module.exports = __webpack_public_path__ + "static/onboarding-fullname-0c84b29e9605ada303a89ecb79e4ba1f.svg";